import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import {CustomValidators} from "ng2-validation";
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import {fadeInOutTranslate} from '../../shared/elements/animation';
import { Router } from'@angular/router';
import { AngularFireDatabase} from "angularfire2/database";
import swal from 'sweetalert2';
import { Upload } from '../../uploads/shared/upload';
import * as _ from "lodash";
import { UserService } from '../shared/user.service';
import { MessagingService } from 'app/messagingservice';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';
import { DateService } from 'app/date/date.service';
import { NotificationToastService } from 'app/notification/notification-toast.service';
export const search_id = {
  id: ""
};
@Component({
  selector: 'app-admins',
  templateUrl: './admins.component.html',
  styleUrls: ['./admins.component.css'],
  animations: [fadeInOutTranslate],
  providers:[AngularFireDatabase, NotificationToastService, UserService, LogisticsService,DateService]
})

export class AdminsComponent implements OnInit {
  myForm: FormGroup;
  userrole: string = '';
  myFormEdit: FormGroup;
  selectedFiles: FileList;
  currentUpload: Upload;
  hasFile: Boolean = false;
  submitted: boolean;
  error: String = '';
  hasError: boolean;

  public basePath:string = '/uploads';
  public imageToUpload = "assets/images/avatar-4.png";
  public sortOrder: string = "desc";
  public sortBy: string = "";
  public data: any;
  public rowsOnPage: number = 10;
  public filterQuery: string = "";

  admin:any;
  message: any = "askjgg";
  branchList: any;
  branchArray:any;
  constructor(public af: AngularFireAuth,public db:AngularFireDatabase,private router: Router, private userService: UserService, private nf:NotificationToastService,private msgService: MessagingService, private logisticsService: LogisticsService, private dateService:DateService) {
    this.initializeForm();
    //console.log("date ",new Date());
    this.userrole = localStorage.getItem('courierapp_role');
    var user = firebase.auth().currentUser;
    ////console.log("user token ",user.getIdToken());

    user.getToken().then((token)=>{
      ////console.log("user token ",token);
    });
    firebase.database().ref('fcmTokens').once('value').then(allTokens => {
      if (allTokens.val()) {
        const tokens = Object.keys(allTokens.val());
      }
    });

    this.msgService.getPermission()
    this.msgService.receiveMessage()
    this.message = this.msgService.currentMessage;
    this.getAllBranch();
  }
  
  ngOnInit() {
    this.userrole = localStorage.getItem('courierapp_role');
    var x = this.userService.getAllUser();
  x.snapshotChanges().subscribe(item=>{
    this.data = [];
    item.forEach(element =>{
      var y = element.payload.toJSON();
      if(element.payload.child("role").val() == "admin" || element.payload.child("role").val() == "super admin")
      {
        y["$key"] = element.key;
        this.data.push(y);
      }
    });
  });

  this.checkSearchId();
  }
  checkSearchId()
  {
    if(search_id.id != "")
    {
      this.filterQuery = search_id.id;
    }
  }
  private initializeForm()
  {
    let name = new FormControl('', Validators.required);
    let username = new FormControl('', Validators.required);
    let email = new FormControl('', [Validators.required,Validators.email]);
    let phone = new FormControl('', [Validators.required,Validators.maxLength(12)]);
    let password = new FormControl('', Validators.required);
    let rpassword = new FormControl('', [Validators.required,CustomValidators.equalTo(password)]);
    let branch = new FormControl('Select Branch', Validators.required);
    let code = new FormControl("", Validators.required);
    this.myForm = new FormGroup({
      name:name,
      username: username,
      email:email,
      password: password,
      rpassword: rpassword,
      code: code,
      phone: phone,
      branch:branch
    });
    this.myForm.reset();
    this.myForm.controls["code"].setValue('+966');
  }
  phone_error:boolean = false;
  public onSubmit() {
    this.hasError = false;
    this.submitted = true;
    this.phone_error = false;
    var phone = this.myForm.value.phone;
    if(phone.length != this.maxLength)
      {
        this.phone_error = true;
        return;
      }
     else if(this.myForm.valid) {
      if(this.hasFile && this.selectedFiles.length!=0)
      {
        let file = this.selectedFiles.item(0);
        this.currentUpload = new Upload(file);
        firebase.database().ref("users").orderByChild("userName").equalTo(this.myForm.value.username).once("value",(snapshot)=>{
          if(snapshot.numChildren() > 0)
          {
            alert("user name exists");
          }
          else
          {
            this.createUser(this.myForm.value.email,this.myForm.value.password,this.currentUpload);
          }
        });
      }
      else{
        firebase.database().ref("users").orderByChild("userName").equalTo(this.myForm.value.username).once("value",(snapshot)=>{
          if(snapshot.numChildren() > 0)
          {
            alert("user name exists");
          }
          else
          {
            this.createUser(this.myForm.value.email,this.myForm.value.password,null);
          }
        });
      }
    } 
  }
  
  public detectFiles(event) {
    this.hasFile = true;
    this.selectedFiles = event.target.files;
    this.readUrl(event);
    }
    public readUrl(event:any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event:any) => {
        this.imageToUpload = event.target.result;
      } 
      reader.readAsDataURL(event.target.files[0]);
    }
  }
  public func()
  {
    this.imageToUpload = "assets/images/avatar-4.png";
    this.hasFile = false;
  }
  
  public refresh()
  {
    this.sortBy = "";
    this.filterQuery = "";
  }
  private createUser(email:string,password:string,currentUpload:Upload)
  {
    firebase.database().ref("users").orderByChild("phoneNumber").equalTo(this.myForm.value.phone).once("value",(snapshot)=>{
      if(snapshot.numChildren() > 0)
      {
        alert("phone number exists");
      }
      else
      {
        this.af.auth.createUserWithEmailAndPassword(email,password)
        .then(
        (success) => {
            var userId = this.af.auth.currentUser.uid;
            if(this.hasFile && this.selectedFiles.length!=0)
            {
              this.uploadFile(userId,currentUpload);
            }
            else
            {
              this.saveUserData(null,userId);
            }
        })
        .catch(
        (err) => {
            //console.log(err);
            this.hasError = true;
            this.error = err;
        });
      }
    });
    
  }
  //to upload file
  private uploadFile(userId,upload)
  {
    let storageRef = firebase.storage().ref();
    let uploadTask = storageRef.child(`${this.basePath}/${"profileImages"}/${userId}`).put(upload.file);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
    (snapshot) =>  {
    upload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100;
    },
    (error) => {
      this.nf.addToast({title:'Error', msg:'Error while uploading photo', timeout: 5000, theme:'material', position:'bottom-right', type:'error'});
    },
    () => {
    upload.url = uploadTask.snapshot.downloadURL;
    upload.name = upload.file.name;
    this.saveUserData(upload.url,userId);
    });
  }

  //to add user data to database
  private saveUserData(uploadUrl:string,userId:string)
  {
    var usersRef = firebase.database().ref("users");
    var date_time = this.dateService.getTimeandDate();
    usersRef.child(userId).set({ 
    name: this.myForm.value.name,
    userName:this.myForm.value.username,
    email: this.myForm.value.email,
    role: "admin",
    imageUrl:uploadUrl,
    code: this.myForm.value.code,
    phoneNumber: this.myForm.value.phone,
    status: "1",
    branch:this.myForm.value.branch,
    createdAt: date_time.date,
    createdTime: date_time.time
    }).then(
      (success) => {
        this.myForm.reset();
        this.myForm.controls["code"].setValue('+966');
        this.submitted = false;
        this.currentUpload = null;
        this.imageToUpload = "assets/images/avatar-4.png";
        this.nf.addToast({title:'Registration Success', msg:'New Admin has been added', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
      });
  }

  private view(id)
  {
    search_id.id = this.filterQuery;
    this.router.navigate(['/manage-admin'], { queryParams : {key: id, from: 'admin'}  });
  }

  keyPressUserName(event)
  {
    var format = /[a-zA-Z0-9-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !format.test(inputChar)) {
      event.preventDefault();
    }
  }
  deleteuser(userId)
  {
    var user = firebase.auth().currentUser;
    user.delete().then(function() {
      // User deleted.
    }).catch(function(error) {
      // An error happened.
    });
  }
  maxLength: number =9;
  onChangeCountry(e)
  {
    this.phone_error = false;
    switch(e.target.value)
    {
      case "+91" : this.maxLength  = 10;
      this.myForm.controls["phone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      break;
      case "+966" : this.maxLength  = 9;
      this.myForm.controls["phone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      break;
    }
  }
  public keyPress(event: any) {
    this.phone_error = false;
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    else
    {
      var phone = this.myForm.value.phone;
      if(phone.length >= this.maxLength)
      {
        event.preventDefault();
      }
    }
  }
  preventPaste(e)
  {
    e.preventDefault();
    return false;
  }
  getAllBranch()
  {
    var drivers= this.logisticsService.getBranch();
    drivers.snapshotChanges().subscribe(item=>{
      this.branchList = [];
      this.branchArray = [];
      item.forEach(element =>{
        var data = element.payload.toJSON();
        data["$key"] = element.key;
        this.branchList.push(data);
        this.branchArray[element.key] = data;
        
      });
    });
  }
  isChangeBranch: boolean = false;
  selectedBranch:any;
  changeBranch(shipmentId)
  {
    this.isChangeBranch = true;
    this.rowIdBranch = shipmentId;
  }
  getSelectedBranch(e)
  {
    this.selectedBranch = e.target.value;
  }
  rowIdBranch:any;
  assignToBranch(userId)
  {
    if(this.selectedBranch != null)
    {
      firebase.database().ref("users").child(userId).child("branch").set(this.selectedBranch).then(()=>{
        this.selectedBranch = null;
        this.isChangeBranch = false;
        this.rowIdBranch = null;
      });
    }
      else
      {
        this.rowIdBranch = null;
        this.isChangeBranch = false;
      }
  }
}


// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/users/admins/admins.component.ts